import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {appendOfferListQuery} from "../helpers/offer_list_url/build_offer_list_url";
import {MODAL_ONLY_SEARCH_PARAMS} from "../list/helpers/get_listing_layout_search_key";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {useOfferListingParams} from "./use_offer_listing_params";

export function useOffersMapUrl() {
    const {search} = useLocation();
    //  TODO: Add credit 2% handling and remove ts ignore below
    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useOfferListingParams();

    // modal-only params describe transient UI state, they must not leak into the map url
    const validSearch = omit(parseSearch(search), ["page", "sort", ...MODAL_ONLY_SEARCH_PARAMS]);

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        const abroadMapLink = abroadRegionSlug ? rpAppLink.offer.mapAbroadRegion : rpAppLink.offer.mapAbroadCountry;

        return appendOfferListQuery(
            abroadMapLink({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);
        const query = {
            ...validSearch,
            ...subFilterQuery
        };
        return appendOfferListQuery(rpAppLink.offer.mapFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendOfferListQuery(
            rpAppLink.offer.mapFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendOfferListQuery(rpAppLink.offer.mapFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiListMap(), validSearch);
}
import {useLocation} from "react-router";

import {omit} from "@pg-mono/nodash";
import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {appendOfferListQuery} from "../helpers/offer_list_url/build_offer_list_url";
import {MODAL_ONLY_SEARCH_PARAMS} from "../list/helpers/get_listing_layout_search_key";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {useOfferListingParams} from "./use_offer_listing_params";

export function useOffersMapUrl() {
    const {search} = useLocation();
    //  TODO: Add credit 2% handling and remove ts ignore below
    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useOfferListingParams();

    // modal-only params describe transient UI state, they must not leak into the map url
    const validSearch = omit(parseSearch(search), ["page", "sort", ...MODAL_ONLY_SEARCH_PARAMS]);

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        const abroadMapLink = abroadRegionSlug ? rpAppLink.offer.mapAbroadRegion : rpAppLink.offer.mapAbroadCountry;

        return appendOfferListQuery(
            abroadMapLink({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);
        const query = {
            ...validSearch,
            ...subFilterQuery
        };
        return appendOfferListQuery(rpAppLink.offer.mapFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendOfferListQuery(
            rpAppLink.offer.mapFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendOfferListQuery(rpAppLink.offer.mapFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiListMap(), validSearch);
}
